<template>
    <div class="datafield-validation-statement">
        <slot name="before"></slot>

        <!-- DATAFIELD ID -->
        <div>
            <button-select
                v-model="statement.datafieldId"
                :options="datafieldOptions"
                :class="{ error: validationErrors.datafieldId.$error }" />

            <p
                v-if="isDatafieldOptionOutOfUse"
                class="datafield-validation-field__error"
                v-html="datafieldOptionOutOfUseMessage"></p>
        </div>

        <!-- CMP_OPERATOR -->
        <ui5-select
            v-if="showComparatorOperator"
            @change="statement.cmpOperator = $event.detail.selectedOption.value"
            :class="{ error: validationErrors.cmpOperator.$error }">
            <ui5-option :value="null" :selected="statement.cmpOperator == null">
                ---
            </ui5-option>
            <ui5-option
                v-for="operator in comparatorOperators"
                :key="operator"
                :selected="statement.cmpOperator === operator"
                :value="operator">
                {{ operator }}
            </ui5-option>
        </ui5-select>

        <!-- CMP_VALUE / CMP_DATAFIELD -->
        <datafield-validation-field
            v-if="showComparatorField"
            name="cmp"
            :datafields="validDatafields"
            :statement="statement"
            :error="
                validationErrors.cmpValue.$error ||
                validationErrors.cmpDatafieldId.$error ||
                validationErrors.cmpDatafieldOptionId.$error
            " />

        <template v-if="isStatementNumeric && showAction">
            <!-- ACTION_OPERATOR -->
            <ui5-select
                @change="
                    statement.actionOperator =
                        $event.detail.selectedOption.value
                "
                :class="{ error: validationErrors.actionOperator.$error }">
                <ui5-option
                    :value="null"
                    :selected="statement.actionOperator == null">
                    ---
                </ui5-option>
                <ui5-option
                    v-for="operator in actionOperators"
                    :key="operator"
                    :selected="statement.actionOperator === operator"
                    :value="operator">
                    {{ operator }}
                </ui5-option>
            </ui5-select>

            <!-- ACTION_VALUE / ACTION_DATAFIELD -->
            <datafield-validation-field
                name="action"
                :datafields="validDatafields"
                :statement="statement"
                :error="
                    validationErrors.actionValue.$error ||
                    validationErrors.actionDatafieldId.$error ||
                    validationErrors.actionDatafieldOptionId.$error
                " />
        </template>

        <div class="divider"></div>

        <slot name="after"></slot>
    </div>
</template>
<script>
import DatafieldValidationField from './DatafieldValidationField.vue';
import ButtonSelect from './ButtonSelect.vue';

export default {
    props: {
        statement: {
            type: Object,
            required: true,
        },
        datafields: {
            type: Array,
            required: true,
        },
        showComparatorOperator: {
            type: Boolean,
            default: true,
        },
        showComparatorField: {
            type: Boolean,
            default: true,
        },
        showAction: {
            type: Boolean,
            default: true,
        },
        validationErrors: {
            type: Object,
        },
    },
    data() {
        return {
            actionOperators: ['+', '-', '*', '/'],
        };
    },
    computed: {
        datafieldOptions() {
            return this.datafieldsInUse.map((datafield) => ({
                label: datafield.useAbsoluteValue
                    ? `| ${datafield.label} |`
                    : datafield.label,
                value: parseInt(datafield.datafieldId),
            }));
        },
        datafieldsInUse() {
            return this.datafields.filter((df) => df.inUse === true);
        },
        isStatementNumeric() {
            const datafield = this.datafields.find(
                (df) => df.datafieldId == this.statement.datafieldId
            );
            return this.isDatafieldNumeric(datafield);
        },
        comparatorOperators() {
            return this.isStatementNumeric
                ? ['>', '>=', '<', '<=', '=', '!=']
                : ['=', '!='];
        },
        validDatafields() {
            if (this.isStatementNumeric) {
                return this.datafields.filter((df) =>
                    this.isDatafieldNumeric(df)
                );
            }

            return this.datafields;
        },
        isDatafieldOptionOutOfUse() {
            const datafield = this.datafields.find(
                (df) => df.datafieldId == this.statement.datafieldId
            );
            return !datafield || !datafield.inUse;
        },
        datafieldOptionOutOfUseMessage() {
            const datafield = this.datafields.find(
                (df) => df.datafieldId == this.statement.datafieldId
            );
            if (datafield) {
                const optionLabel = datafield.label;
                return `Dataveld <b>${optionLabel}</b> is niet meer beschikbaar.Kies een ander veld.`;
            }

            if (this.statement.datafieldId) {
                return 'Het geselecteerde dataveld is niet meer beschikbaar';
            }

            return null;
        },
    },
    methods: {
        isDatafieldNumeric(datafield) {
            return (
                datafield !== undefined &&
                (datafield.datatypeText === 'int' ||
                    datafield.datatypeText === 'double')
            );
        },
    },
    components: {
        DatafieldValidationField,
        ButtonSelect,
    },
};
</script>
